<template>
  <div class="text-block">
    <h3 class="text-title">{{ title }}</h3>
    <p class="text-content">{{ content }}</p>
  </div>
</template>

<script>
export default {
  name: 'InfoTextEmphasized',
  props: {
    title: String,
    content: String
  }
};
</script>

<style scoped>
.text-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.text-title {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
}

.text-content {
  padding: 32px;
  border-radius: 16px;
  background: linear-gradient(135deg, #207868 0%, #2a9d8f 100%);
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  box-shadow: 0 10px 30px rgba(32, 120, 104, .3);
}
</style>
